import { PictureComponentV2 } from 'app/components/commons/PictureComponentV2/PictureComponentV2';
import { RetrieveImage } from 'app/components/pages/Extranet/commons/RetrieveImage/RetrieveImage';
import type { PictureView } from 'app/typings/core/common/pictureView/pictureView';

import styles from './ItemPreview.module.scss';

type ItemPreviewProps = {
  title: string;
  path?: string;
  alt?: string;
  name: string;
  images?: PictureView[];
};

export const ItemPreview = ({
  title,
  path,
  alt,
  name,
  images,
}: ItemPreviewProps) => {
  return (
    <div className={styles.section}>
      <p className={styles.defaultTitle}>{title}</p>
      <div className={styles.container}>
        <div className={styles.row}>
          {images ? (
            <RetrieveImage
              images={images as [PictureView, PictureView, PictureView]}
            />
          ) : (
            <div className={styles.emoji}>
              <PictureComponentV2
                path={path ?? ''}
                alt={alt}
                width={24}
                height={24}
              />
            </div>
          )}
          <p className={styles.name}>{name}</p>
        </div>
      </div>
    </div>
  );
};
